import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import qs from 'query-string';
import { useQuery } from 'react-apollo';

import FreemiumEventTutorialWizard from './FreemiumEventTutorialWizard';
import FullScreenLoader from '../../../../../components/global/FullScreenLoader';
import { AlbumFolderPRO } from '../../../../../graphql/queries/album-folder';
import { AlbumDataPRO } from '../../../../../graphql/queries/albums';
import { postNativeAppFreemiumEventTutorialConfigStepChange } from '../../../../../services/native-bridge/native-apps-interface';
import useIsNativeWebView from '../../../../../services/native-bridge/hooks/useIsWebView';

const FreemiumEventTutorialStandaloneWizard = () => {
  const { entityId } = useParams();
  const location = useLocation();
  const isNativeWebView = useIsNativeWebView(true);

  const { stepKeys, activeStepKey } = qs.parse(location?.search, {
    arrayFormat: 'bracket',
  });

  const { data: { albumFolder } = {} } = useQuery(AlbumFolderPRO, {
    variables: {
      id: entityId,
    },
    skip: !entityId,
  });

  const { data: { album } = {} } = useQuery(AlbumDataPRO, {
    variables: {
      id: entityId,
    },
    skip: !entityId,
  });

  const entity = albumFolder || album;

  const onStepChanged = data => {
    postNativeAppFreemiumEventTutorialConfigStepChange({ entityId, ...data });
  };

  const configuration =
    stepKeys && activeStepKey ? { stepKeys, activeStepKey } : undefined;

  if (!entity) {
    return <FullScreenLoader />;
  }

  return (
    <FreemiumEventTutorialWizard
      modalOnly
      entity={entity}
      configuration={configuration}
      onStepChanged={isNativeWebView ? onStepChanged : undefined}
    />
  );
};

export default FreemiumEventTutorialStandaloneWizard;
